"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const constants_1 = require("../constants");
const types_1 = require("../types");
const decodeTransactionMode = (action) => {
    if (!action) {
        return "send";
    }
    if (!action.category) {
        return "send";
    }
    if (action.category !== "stake") {
        return "send";
    }
    const mode = action.name;
    return mode;
};
class ElrondApi {
    constructor(API_URL, DELEGATION_API_URL) {
        this.API_URL = API_URL;
        this.DELEGATION_API_URL = DELEGATION_API_URL;
    }
    getAccountDetails(addr) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { balance, nonce, isGuarded }, } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.API_URL}/accounts/${addr}?withGuardianInfo=true`,
            });
            return {
                balance,
                nonce,
                isGuarded,
            };
        });
    }
    getProviders() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: providers } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.DELEGATION_API_URL}/providers`,
            });
            return providers;
        });
    }
    getNetworkConfig() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { data: { config: { erd_chain_id: chainId, erd_denomination: denomination, erd_min_gas_limit: gasLimit, erd_min_gas_price: gasPrice, erd_gas_per_data_byte: gasPerByte, erd_gas_price_modifier: gasPriceModifier, }, }, }, } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.API_URL}/network/config`,
            });
            return {
                chainID: chainId,
                denomination,
                gasLimit,
                gasPrice,
                gasPerByte,
                gasPriceModifier,
            };
        });
    }
    submit(signedOperation) {
        return __awaiter(this, void 0, void 0, function* () {
            const transaction = Object.assign(Object.assign({}, signedOperation.rawData), { signature: signedOperation.signature });
            const { data: { data: { txHash: hash }, }, } = yield (0, network_1.default)({
                method: "POST",
                url: `${this.API_URL}/transaction/send`,
                data: transaction,
            });
            return hash;
        });
    }
    getHistory(addr, startAt) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: transactionsCount } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.API_URL}/accounts/${addr}/transactions/count?after=${startAt}`,
            });
            let allTransactions = [];
            let from = 0;
            while (from < transactionsCount) {
                const { data: transactions } = yield (0, network_1.default)({
                    method: "GET",
                    url: `${this.API_URL}/accounts/${addr}/transactions?after=${startAt}&from=${from}&size=${constants_1.MAX_PAGINATION_SIZE}&withOperations=true&withScResults=true`,
                });
                for (const transaction of transactions) {
                    transaction.mode = decodeTransactionMode(transaction.action);
                }
                allTransactions = [...allTransactions, ...transactions];
                from = from + constants_1.MAX_PAGINATION_SIZE;
            }
            return allTransactions;
        });
    }
    getAccountDelegations(addr) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: delegations } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.DELEGATION_API_URL}/accounts/${addr}/delegations`,
            });
            return delegations;
        });
    }
    getESDTTransactionsForAddress(addr, token, startAt) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: tokenTransactionsCount } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.API_URL}/accounts/${addr}/transactions/count?token=${token}&after=${startAt}`,
            });
            let allTokenTransactions = [];
            let from = 0;
            while (from < tokenTransactionsCount) {
                const { data: tokenTransactions } = yield (0, network_1.default)({
                    method: "GET",
                    url: `${this.API_URL}/accounts/${addr}/transactions?token=${token}&from=${from}&after=${startAt}&size=${constants_1.MAX_PAGINATION_SIZE}`,
                });
                allTokenTransactions = [...allTokenTransactions, ...tokenTransactions];
                from = from + constants_1.MAX_PAGINATION_SIZE;
            }
            for (const esdtTransaction of allTokenTransactions) {
                esdtTransaction.transfer = types_1.ElrondTransferOptions.esdt;
            }
            return allTokenTransactions;
        });
    }
    getESDTTokensForAddress(addr) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: tokensCount } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.API_URL}/accounts/${addr}/tokens/count`,
            });
            let allTokens = [];
            let from = 0;
            while (from < tokensCount) {
                const { data: tokens } = yield (0, network_1.default)({
                    method: "GET",
                    url: `${this.API_URL}/accounts/${addr}/tokens?from=${from}&size=${constants_1.MAX_PAGINATION_SIZE}`,
                });
                allTokens = [...allTokens, ...tokens];
                from = from + constants_1.MAX_PAGINATION_SIZE;
            }
            return allTokens;
        });
    }
    getESDTTokensCountForAddress(addr) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: tokensCount } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.API_URL}/accounts/${addr}/tokens/count`,
            });
            return tokensCount;
        });
    }
    getBlockchainBlockHeight() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: [{ round: blockHeight }], } = yield (0, network_1.default)({
                method: "GET",
                url: `${this.API_URL}/blocks?shard=${constants_1.METACHAIN_SHARD}&fields=round`,
            });
            return blockHeight;
        });
    }
}
exports.default = ElrondApi;
//# sourceMappingURL=apiCalls.js.map